import RLCard from "../../../../../../components/card/RLCard";
import { COMPONENT_IDS, SECTIONS } from "../../../../consts";
import {
  useGetReportSummary,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { Link } from "../../../../../../components/link";
import { RenderWhen } from "../../../../../../components";
import AttributionCardContent from "../../../../../search/components/ticard/components/AttributionCardContent";
import { Tooltip } from "../common";
import { pathToSS } from "../../../../util";
import styles from "../../../../containers/report_summary/report-summary.module.scss";
import { PDFExport } from "../../@types/PDFExport";
import { useGetTiCardData } from "../../../../../search/components/ticard/hooks";
import useGetIOCSummary from "../../../../hooks/useGetIOCSummary";

export const ATTRIBUTION_DATA_CARD_ID = "report-summary-attribution-data-card";

type Props = PDFExport;

const ThreatIntelligenceCard = ({ isPdfView }: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();

  const { data: reportSummaryData } = useGetReportSummary(
    hash,
    sourceId,
    relationshipId
  );

  const { data: tiCardData, isLoading: tiLoading } = useGetTiCardData(
    reportSummaryData?.threat_name
  );
  const { data: iocData, isLoading: iocLoading } = useGetIOCSummary(hash || "");

  const hasData = Boolean(tiCardData || iocData);
  const isLoading = tiLoading || iocLoading;

  if (!tiLoading && !iocLoading && !tiCardData && !iocData) return;

  return (
    <RLCard
      id={ATTRIBUTION_DATA_CARD_ID}
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              placement="top"
              message={DESCRIPTIONS[COMPONENT_IDS.ATTRIBUTION_DATA]}
            >
              <span>Attribution Data</span>
            </Tooltip>
          }
          LinkComponent={
            <RenderWhen condition={!isLoading && hasData}>
              <Link
                className={styles.link}
                to={pathToSS(
                  hash,
                  sourceId,
                  SECTIONS.FILE_ANALYSIS.ATTRIBUTION_DATA
                )}
                data-testid="threat_intelligence_attribution_data_link"
              >
                Open Full Attribution Data Report
              </Link>
            </RenderWhen>
          }
        />
      }
      content={
        <RLCard.Content>
          <AttributionCardContent
            tiCardData={tiCardData}
            isTiCardDataLoading={tiLoading}
            sampleIOCData={iocData}
            iocDataLoading={iocLoading}
            noBorder
            prerenderGraphImage={isPdfView}
          />
        </RLCard.Content>
      }
      data-testid="report_summary_threat_intelligence_card"
    />
  );
};

export default ThreatIntelligenceCard;
